import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isAuthenticate } from "./fetchApi";

const CartProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        let cartArr = [];
        try {
          cartArr = JSON.parse(localStorage.getItem("cart") || "[]");
          if (!Array.isArray(cartArr)) cartArr = [];
        } catch (e) {
          cartArr = [];
        }
        const orderJustCompleted = localStorage.getItem("orderJustCompleted") === "1";

        if ((cartArr.length !== 0 || orderJustCompleted) && isAuthenticate()) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

export default CartProtectedRoute;
